import React from 'react';
import {
  histologicalTumorTypeFieldsData,
  histologicalGradeFieldsData,
  tumourExtentFieldsData,
  presentStatusFieldsData,
} from './caseAndSpecimenAnalysisFieldsData';
import {
  histologicalTumorTypeJSX,
  histololicalGradeJSX,
  tumourExtentJSX,
  presentStatusCollectionJSX,
  regularSaveButtonJSX,
  reopenAnalysisButtonJSX,
  submitAnalysisButtonJSX,
  submitAnalysisAndGoToNextButtonJSX,
} from './caseAndSpecimenAnalysisFieldsJSX';
import FormHeader from '../shared/FormHeader';
import { userRoles } from '../../constants';
import PersonalInformationForm from '../personalInformationForm/PersonalInformationForm';


const SpecimenAnalysisComponent = ({
  getFieldValue,
  numberOfCores,
  userRole,
  specimenId,
  analysisMarkedAsDone,
  pristine,
  submitting,
  handleMarkAsDone,
  handleSaveAndGoToNext,
  invalid,
  setFieldValue,
  containsUnsavedChanges,
  printWindowIsOpen,

}) => {
  const titleRow1 = 'Prostate Core Needle Biopsy Histopathology Report';
  const titleRow2 = (userRole !== userRoles.val_pathologist ? 'Part 2 - Specimen Level' : 'Specimen Level');

  const disableSaveButtons = (pristine && !containsUnsavedChanges)
    || submitting
    || analysisMarkedAsDone
    || invalid;

  let filteredFieldsData = [
    ...histologicalTumorTypeFieldsData,
    ...histologicalGradeFieldsData,
    ...tumourExtentFieldsData,
    ...presentStatusFieldsData,
  ];

  const toExcludeFields = [];

  if (userRole === userRoles.val_pathologist) {
    toExcludeFields.push(
      'percentageGleasonPattern',
      'specifyGleasonPatternPercentage',
      'perineuralInvasion',
      'seminalDuctInvasion',
      'lymphovascularInvasion',
      'epe',
      'intraductalCarcinoma',
      'coexistentPathology',
    );
  }

  if (toExcludeFields.length > 0) {
    filteredFieldsData = filteredFieldsData.filter(field => !toExcludeFields.includes(field.name));
  }


  return (
    <>
      <FormHeader titleRow1={titleRow1} titleRow2={titleRow2} />
      {userRole !== userRoles.val_pathologist && (
        <div className="extra-title-specimen-level">
          <p>FOR EACH SPECIMEN - COMPLETE THE FOLLOWING</p>
          <p>specimen id: <span>{specimenId}</span></p>
        </div>
      )}
      <div className="side side-left">
        <fieldset
          className="side-content"
        >
          {histologicalTumorTypeJSX(filteredFieldsData, getFieldValue)}
          {histololicalGradeJSX(filteredFieldsData, getFieldValue, setFieldValue)}
          <div className="show-in-print">{tumourExtentJSX(filteredFieldsData, numberOfCores, getFieldValue, setFieldValue)}</div>
        </fieldset>
      </div>
      <div className="side side-right">
        <fieldset
          className="side-content"
        >
          <div className="hide-in-print">{tumourExtentJSX(filteredFieldsData, numberOfCores, getFieldValue, setFieldValue)}</div>
          {presentStatusCollectionJSX(filteredFieldsData, getFieldValue, setFieldValue)}
        </fieldset>

        <div className="terms-agreement-and-save">
          {regularSaveButtonJSX(disableSaveButtons)}
        </div>
        {(userRole === userRoles.val_pathologist) && (
          <>
            {!analysisMarkedAsDone && submitAnalysisButtonJSX(handleMarkAsDone, disableSaveButtons)}
            {analysisMarkedAsDone && reopenAnalysisButtonJSX(handleMarkAsDone)}
            {!analysisMarkedAsDone && submitAnalysisAndGoToNextButtonJSX(handleSaveAndGoToNext, disableSaveButtons)}
          </>
        )}
      </div>
    </>
  );
};
export default SpecimenAnalysisComponent;